import React from "react";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
import { Divider, List, ListItem, ListItemText, Button } from "@curves/ui-base";
import { initialDate, parseDate } from "@util/moment";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import useMemberWorkoutApi from "@apis/useMemberWorkoutApi";

const CheckInDialog = ({ open = true, sourceData, onClose, refresh }) => {
	const { title, checkInRecord, memberID } = sourceData || {};
	const { deleteWorkoutRecordApi } = useMemberWorkoutApi();
	const handleDelete = date => {
		const params = {
			memberID: memberID,
			assignDate: parseDate(initialDate(date)),
		};
		deleteRecordApi(params);
	};

	const deleteRecordApi = async params => {
		const resp = await deleteWorkoutRecordApi(params);
		if (resp) {
			onClose();
			typeof refresh === "function" && refresh();
		}
	};

	if (!open) return null;

	return (
		<Dialog className="simple-content dialog" PaperProps={{ className: "wx-40rem" }} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>{title}</GradientColorHeader>
			<DialogContent>
				<List>
					<ListItem>
						<ListItemText primary="運動場所" />
						<ListItemText primary={checkInRecord?.workoutClubName ?? '無'} />
					</ListItem>
					<Divider />
					<ListItem>
						<ListItemText primary="入場時間" />
						<ListItemText primary={checkInRecord?.checkinTime ?? '無'} />
					</ListItem>
					<Divider />
					<ListItem>
						<ListItemText primary="離場時間" />
						<ListItemText primary={(checkInRecord?.checkinTime === checkInRecord?.checkoutTime) 
							? '無離場紀錄'
							: checkInRecord?.checkoutTime ?? '無'} />
					</ListItem>
				</List>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" onClick={() => handleDelete(title)}>
					刪除紀錄
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CheckInDialog;
